var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"container",staticClass:"container"}),_vm._v(" "),_vm._l((_vm.getSections()),function(section,index){return (section.visible)?_c('section',{staticClass:"section",attrs:{"id":_vm.sectionId(section)}},[_vm._t("page",null,{section:section,index:index})],2):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a9d717a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 274
// module chunks = 0